import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { IBtn, IFpxShell, IShellButtonAction } from '../models/index';

/** Entry shell */
@Injectable({
  providedIn: 'root',
})
export class FpxEntryShellService implements IFpxShell {
  formGroup!: FormGroup<any>;

  onBtnClick = (action: keyof IShellButtonAction) => {
    if ((this as IFpxShell)[action]) {
      ((this as IFpxShell)[action] as any)();
    }
  };

  btnList: IBtn[] = [];

  doPreInit() {
    console.log('child service init call');
    this._getTransactionRefNumber();
  }

  private _getTransactionRefNumber() {
    console.log('transaction ref number call');
  }

  onReset = () => {
    console.log('entry shell reset');
  };

  onSubmit = () => {
    console.log('entry shell submit');
  };

  _setFormGroup(form: FormGroup) {
    this.formGroup = form;
    this.loadDependencies();
  }

  get formInvalid(): boolean {
    return this.formGroup?.invalid;
  }

  loadDependencies() {
    this.btnList = [
      {
        label: 'Reset',
        buttonAction: 'onReset',
        buttonClass: 'btn-tertiary',
        buttonType: 'reset',
      },
      {
        label: 'Submit',
        buttonAction: 'onSubmit',
        buttonClass: 'btn-primary',
        buttonType: 'submit',
        disabled: this.formInvalid,
      },
    ];
  }
}
